import { fork } from 'redux-saga/effects';
import { offersConfigWatcher } from './OffersSagas';
import { filtersConfigWatcher } from './filtersSaga';

export default function* Offers() {
  yield fork(offersConfigWatcher);
  yield fork(filtersConfigWatcher);
}
